import { createReducer, on } from '@ngrx/store';
import { TaskDetailState } from '../../models/task-details-state';

import * as taskDetailsActions from './task-detail.actions';

export const tasksDetailKey = 'tasksDetail';

export const taskInitialState: TaskDetailState = {
    description: '',
    isLoaded: false,
    isLoading: false,
};

export const tasksDetailReducer = createReducer(
    taskInitialState,
    on(taskDetailsActions.getServiceData, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
    })),
    on(taskDetailsActions.getTaskData, (state) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
    })),
    on(taskDetailsActions.getServiceDataSuccess, (state, response) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        description: response.description
    })),
    on(taskDetailsActions.getTaskDataSuccess, (state, response) => ({
        ...state,
        isLoaded: true,
        isLoading: false,
        observation: response.observation
    })),
);
